import { render, staticRenderFns } from "./PD.vue?vue&type=template&id=4339c33c&scoped=true"
import script from "./PD.vue?vue&type=script&lang=js"
export * from "./PD.vue?vue&type=script&lang=js"
import style0 from "./PD.vue?vue&type=style&index=0&id=4339c33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4339c33c",
  null
  
)

export default component.exports